import type { IconData } from '@stacksjs/iconify-core'

export const handPointLeft: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M397.784 472h-159.7a24.07 24.07 0 0 1-23.124-17.576L179.838 328H68a52 52 0 0 1 0-104h180v-24.418l-22.6-18.494A90.41 90.41 0 0 1 214.607 51.58a24 24 0 0 1 34.149-2.006L496 272.891v144.168l-85.868 51.521a24 24 0 0 1-12.348 3.42m-153.623-32h151.407L464 398.941V287.109L233.75 79.141a58.437 58.437 0 0 0 11.91 77.18l34.34 28.1V256H68a20 20 0 0 0 0 40h136.162ZM227.307 73.321l.023.02Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default handPointLeft
